export default __webpack_public_path__ + "static/DIGITAL LAMINATES-7d623eaf649e7c57dca5cfb3e4d17ae7.webp";